let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1r9nh")).then(() => parcelRequire('2eUU2'));